import * as React from 'react';
import styled, { keyframes } from 'styled-components';
import { rem } from 'polished';
import { FlexRow } from '../../Defaults/Flexbox/Flexbox';
import { __ } from 'react-i18n';
import { NoItemsWrapper } from '../../Zemplin/General/NoItemsWrapper';
import { DsiProductTabDefault as ProductTabDefault } from './ProductTabDefault';
import { ZemplinLoaderWrapper } from '../../..';
import { TableWrapper } from '../../Zemplin/General/TableWrapper';
import { ProductTabRowMobile } from './ProductTabRowMobile';
import { ProductTabRowTable } from './ProductTabRowTable';
import { TableRow } from '../../Zemplin/General/Table';

interface Props {
  apiUrl: string;
  products: any;
  isFetching: boolean;
  addToCart: any;
  addToRequest: any;
  visible?: boolean;
}

function ProductTableList({
  apiUrl,
  products,
  isFetching,
  addToCart,
  addToRequest,
  visible = true,
}: Props) {
  const productsComponent =
    products &&
    products.map((p: any) => (
      <StyledTableRow key={p.product_id}>
        <ProductTabRowTable
          apiUrl={apiUrl}
          addToCart={addToCart}
          addToRequest={addToRequest}
          product={p}
        />
      </StyledTableRow>
    ));

  const mobileProductsComponent =
    products &&
    products.map((p: any) => (
      <ProductTabDefault
        apiUrl={apiUrl}
        key={p.product_id}
        addToCart={addToCart}
        addToRequest={addToRequest}
        product={p}
      />
    ));

  return (
    <ProductsCardWrapper visible={visible}>
      {isFetching ? (
        <ZemplinLoaderWrapper height={500} />
      ) : (
        <>
          <DesktopListProductsWrapper>
            <TableWrapper
              noItemsText={__('Nenašli sa žiadne produkty')}
              rows={productsComponent}
            />
          </DesktopListProductsWrapper>
          <MobileListProductsWrapper>
            {mobileProductsComponent}
          </MobileListProductsWrapper>
        </>
      )}
    </ProductsCardWrapper>
  );
}

const animateIn = keyframes`
   0% {
    opacity: 0;
    transform: scale(0.6) translateY(-8px);
  }
  
  100% {
    opacity: 1;
  }
`;

const ProductsCardWrapper = styled(FlexRow)<{ visible: boolean }>`
  flex-flow: row wrap;
  margin-bottom: ${({ visible }) => (visible ? rem(24) : 0)};
  display: ${({ visible }) => (visible ? 'flex' : 'none')};
  animation: ${animateIn} 0.2s ease;

  ${({ theme }) => theme.mediab.m810`
      margin-bottom: ${({ visible }) => (visible ? rem(32) : 0)};
  `};
`;

const DesktopListProductsWrapper = styled.div`
  display: block;
  width: 100%;

  ${({ theme }) => theme.mediab.s450`
    display: none;
`}
`;

const MobileListProductsWrapper = styled.div`
  display: none;
  width: 100%;

  ${({ theme }) => theme.mediab.s450`
      display: inline-block;
  `}
`;

const StyledTableRow = styled(TableRow)`
  background-color: ${({ theme }) => theme.colors.white};
  padding: ${rem(16)};
  box-shadow: 0px 1px 4px rgba(0, 0, 0, 0.08);
  border-radius: 4px;
  margin-bottom: ${rem(8)};
`;

export { ProductTableList as DsiProductTableList };
